import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import './Hero.css'; // Import the CSS file

const Hero = ({ onEnrollClick }) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const features = [
    'No Interview Required',
    'Live Training Sessions',
    'Industry Projects',
    'Verified Certificates',
    'Career Guidance',
    'Only ₹599'
  ];

  return (
    <section id="home" className="hero">
      <div 
        className="hero-background"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`
        }}
      />
      
      <div className="hero-container">
        <motion.div
         style={{ marginTop: "40px" }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-content"
        >
          <div className="hero-badge">
            <span>Limited Seats Available</span>
          </div>
          
          <h1 className="hero-title">
            Launch Your Career with Our
            <span className="hero-highlight"> 1+1 Internship Program</span>
          </h1>
          
          <p className="hero-subtitle">
            1 Month Professional Training + 1 Month Hands-on Internship
            <br />
            Get Industry Ready with Live Projects & Expert Mentorship
          </p>

          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={feature}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="feature-item"
              >
                <FiCheckCircle className="feature-icon" />
                <span>{feature}</span>
              </motion.div>
            ))}
          </div>

          <div className="cta-container">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onEnrollClick}
              className="primary-button black-btn"
            >
              Enroll Now @ ₹599
              <FiArrowRight className="button-icon" />
            </motion.button>
            
            {/* <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="secondary-button black-btn-outline"
            >
              Download Brochure
            </motion.button> */}
          </div>

          <div className="stats">
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Students Trained</div>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Industry Experts</div>
            </div>
            <div className="stat-divider" />
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Verified Certificates</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="hero-visual"
        >
          <div className="certificate-card">
            <div className="certificate-header">
              <div className="certificate-logo">DYLORA</div>
              <div className="certificate-badge">VERIFIED</div>
            </div>
            <div className="certificate-content">
              <h3 className="certificate-title">Internship Certificate</h3>
              <p className="certificate-text">
                Awarded for successful completion of training and internship
              </p>
              <div className="certificate-details">
                <div className="detail-item">
                  <span className="detail-label">Duration:</span>
                  <span className="detail-value">2 Months</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Mode:</span>
                  <span className="detail-value">Online</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Fee:</span>
                  <span className="detail-value">₹599 Only</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;